import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import { useEffect, useState } from "react";

const GeneratedBOMDetails = ({
    wo_id,
    item_name,
    work_order_code,
    sales_order_no,
    disabled,
}) => {
    const [wips, setWips] = useState([]);
    const [rms, setRms] = useState([]);
    const { useFetch } = useAPIQuery({
        key: "checkBOM",
        endpoint: `/api/check-bom/`,
    });

    const { data, isFetching, refetch } = useFetch({
        params: { work_order_id: wo_id },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
        enabled: false,
    });

    const columns = [
        {
            accessor: "item_code",
            header: "Item Id",
        },
        {
            accessor: "item_name",
            header: "Item Name",
        },
        {
            accessor: "category",
            header: "Category",
        },
        {
            accessor: "item_per_product",
            header: "Item/Pro",
        },
        {
            accessor: "allotted_stock",
            header: "Allotted Stock",
        },
        {
            accessor: "work_order_req_quantity",
            header: "Work Order Require Quantity",
        },
        {
            accessor: "uom",
            header: "UOM",
        },
    ];

    const columnsRM = [
        {
            accessor: "item_code",
            header: "Item Id",
        },
        {
            accessor: "item_name",
            header: "Item Name",
        },
        {
            accessor: "category",
            header: "Category",
        },
        {
            accessor: "item_per_product",
            header: "Item/Pro",
        },
        {
            accessor: "stock_quantity",
            header: "Stock Quantity",
        },
        {
            accessor: "work_order_req_quantity",
            header: "Work Order Require Quantity",
        },
        {
            accessor: "uom",
            header: "UOM",
        },
    ];

    useEffect(() => {
        if (data) {
            const wipsAva = data?.data?.filter(
                (item) => item?.item?.category === "WIP"
            );
            const rmAva = data?.data?.filter(
                (item) => item?.item?.category === "Raw Material"
            );

            setWips(
                wipsAva.map((wip) => ({
                    id: wip?.id,
                    item_code: wip?.item?.item_code,
                    item_id: wip?.item?.id,
                    item_name: wip?.item?.item_name,
                    category: wip?.item?.category,
                    allotted_stock: wip?.allotted_stock,
                    work_order_req_quantity: wip?.work_order_req_quantity,
                    item_per_product: wip?.bom?.item_per_product,
                    uom: wip?.item?.uom,
                    available: wip?.item?.stock_quantity ?? 0,
                }))
            );
            setRms(
                rmAva.map((rm) => ({
                    id: rm?.id,
                    item_code: rm?.item?.item_code,
                    item_id: rm?.item?.id,
                    item_name: rm?.item?.item_name,
                    category: rm?.item?.category,
                    work_order_req_quantity: rm?.work_order_req_quantity,
                    item_per_product: rm?.bom?.item_per_product,
                    uom: rm?.item?.uom,
                    stock_quantity: rm?.item?.stock_quantity,
                }))
            );
        }
    }, [data]);

    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);

    return (
        <>
            <div
                className="modal fade m-0 p-0"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex={-1}
                id={`generated-bom-details-modal-${wo_id}`}
                aria-modal
            >
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <button
                            type="button"
                            className="close"
                            data-bs-dismiss="modal"
                        >
                            <em
                                className="icon ni ni-cross"
                                aria-hidden="true"
                            ></em>
                        </button>
                        <div className="modal-header">
                            <h5 className="modal-title">BOM Details</h5>
                        </div>
                        <div className="modal-body">
                            <div className="nk-block">
                                <div className="profile-ud-list">
                                    <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                            <span className="profile-ud-label">
                                                Item Name
                                            </span>
                                            <span className="profile-ud-value">
                                                {item_name}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                            <span className="profile-ud-label">
                                                Sales Order No
                                            </span>
                                            <span className="profile-ud-value">
                                                {sales_order_no}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                            <span className="profile-ud-label">
                                                Work Order Code
                                            </span>
                                            <span className="profile-ud-value">
                                                {work_order_code}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content d-flex">
                                        <h6
                                            className="nk-block-title"
                                            style={{ fontSize: "1.3rem" }}
                                        >
                                            WIP
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <Table
                                data={wips}
                                columns={columns}
                                isLoading={isFetching}
                                pagination={false}
                                selectRows={false}
                                globalSearch={false}
                                filterModal={false}
                                editRows={false}
                                deleteRows={false}
                            />
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content d-flex">
                                        <h6
                                            className="nk-block-title"
                                            style={{ fontSize: "1.3rem" }}
                                        >
                                            Raw Material
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <Table
                                data={rms}
                                columns={columnsRM}
                                isLoading={isFetching}
                                pagination={false}
                                selectRows={false}
                                globalSearch={false}
                                filterModal={false}
                                editRows={false}
                                deleteRows={false}
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <button
                type="button"
                className="btn btn-sm btn-secondary ms-2"
                data-bs-toggle="modal"
                data-bs-target={`#generated-bom-details-modal-${wo_id}`}
                onClick={() => refetch()}
                disabled={disabled}
            >
                BOM Details
            </button>
        </>
    );
};

export default GeneratedBOMDetails;
